import { render, staticRenderFns } from "./LoginHistoryList.vue?vue&type=template&id=6bd63c60&"
import script from "./LoginHistoryList.vue?vue&type=script&lang=ts&"
export * from "./LoginHistoryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports